import { createSlice } from '@reduxjs/toolkit';

import { STATUS } from '@constants/status';

import type { RegistrationTypesState } from './types';

export const initialState: RegistrationTypesState = {
  model: [],
  meta: {
    errorMessage: '',
    status: STATUS.SUCCESS,
  },
};

const registrationTypes = createSlice({
  name: 'registrationTypes',
  initialState,
  reducers: {
    reset: () => initialState,
    request: state => {
      state.meta.errorMessage = '';
      state.meta.status = STATUS.LOADING;
    },
    success: (state, action) => {
      state.meta.status = STATUS.SUCCESS;
      state.model = action.payload.result;
    },
    failure: (state, action) => {
      state.meta.status = STATUS.ERROR;
      state.meta.errorMessage = action.payload.errorMessage;
    },
  },
});

export const {
  reset: registrationTypesReset,
  request: registrationTypesRequest,
  success: registrationTypesSuccess,
  failure: registrationTypesFailure,
} = registrationTypes.actions;

export default registrationTypes.reducer;
